export const ORDER_BOOKING_EVENT_BLUEPRINT_TEXT = {
    id: 'oe.orderBookingEventBlueprintForm.name',
    defaultMessage: 'Event Blueprint',
    description: 'Label text'
};

export const ORDER_BOOKING_BLUEPRINT_PUBLIC_NAME_TEXT = {
    id: 'oe.orderBookingEventBlueprintForm.publicName',
    defaultMessage: 'Event Blueprint Public Name',
    description: 'Label text'
};

export const ORDER_BOOKING_BLUEPRINT_PUBLIC_DESCRIPTION_TEXT = {
    id: 'oe.orderBookingEventBlueprintForm.publicDescription',
    defaultMessage: 'Event Blueprint Public Description',
    description: 'Label text'
};

export const PARTICIPANT_LINK_TYPE_TEXT = {
    id: 'oe.orderBookingEventBlueprintForm.participantLink',
    defaultMessage: 'Participant Link',
    description: 'Label text'
};